import React, { useContext, createContext, useState, useRef } from "react";




interface StoreProps {
    Reducer?: {
        setComplaintsInfo: (complaintsInfo: string) => void;
    };
    complaintsInfo?: []


}
const ActivityContext = createContext<StoreProps>({});
export const UseSharedData = () => useContext(ActivityContext);
const SharedData: React.FC = (props) => {


    const [complaintsInfo, setComplaintsInfo] = useState<any>();







    const Reducer: any = {

        setComplaintsInfo

    };

    return (
        <ActivityContext.Provider
            value={{
                Reducer,
                complaintsInfo
            }}
        >
            {props.children}
        </ActivityContext.Provider>
    );
};

export { SharedData };
